<template>
  <div class="content">
    <router-link to="/main/index" tag="div" class="logo">
      <img src="../../static/img/logo.png" alt="">
    </router-link>
    <ul class="nav" @mouseleave="restoreActive">
      <li @mouseenter="isChildBlock('r',item.toLink)" @mouseleave="isChildBlock('c',item.toLink)" v-for="(item,index) in navList" :key="index" @click="navChange('nav',item.toLink,item.navChildList)" :class="{active : navActive==item.toLink}">
        {{item.name}}
        <div></div>
        <ol :class="{activeChildNone : childNone==true && navActive==item.toLink}" v-if="item.navChildList">
          <li v-for="(ite,idx) in item.navChildList" :key="idx" @click.stop="navChange('navChild',item.toLink,ite.toLink)" :class="{activeChild : navChildActive==ite.toLink}">
            <router-link :to="item.toLink+ite.toLink" tag="div">{{ite.name}}</router-link>
          </li>
        </ol>
      </li>
    </ul>
    <div class="search">
      <div :class="{ 'compatible-safari' : isSafari}">
        <img src="../../static/img/icon_search.png" alt="">
        <input ref="isFocus" v-model="searchMsg" @keyup.enter="searchFn" @blur.prevent="blurFn" type="text" placeholder="关键词搜索">
      </div>
    </div>
    <form id="child" action="https://entryhz.qiye.163.com/domain/domainEntLogin" class="loginForm" method="post">
     <input type="hidden" name="domain" value="feifangroup.cn" />
     <table>
      <tbody>
       <tr> <th class="txt">用户名：</th> <td> <input class="text" type="text" name="account_name" /> </td> </tr>
       <tr> <th class="txt">密　码：</th> <td> <input class="text" type="password" name="password" /> </td> </tr>
       </tr>
       <tr><th></th> <td> <input class="btn" type="submit" value="邮箱登录" /> </td> </tr>
      </tbody>
     </table>
    </form>

  </div>
</template>
<script type="text/javascript" src="//mail.qiye.163.com/js/loginjs.jsp"></script>

<script>
    export default {
      name: "myheader",
      data() {
        return {
          reportUrl:'http://mail.feifangroup.cn/',
          display:'block',
          searchMsg:'',
          isFocus:'',
          navIndex:0,
          navActive:'/main/index',
          tapActive:'/main/index',
          navChildActive:'',
          childNone:false,
          isSafari:false
        };
      },
      watch: {
        '$route'(to, from) {
          this.$store.state.toPath=to.path;
          this.$store.state.fromPath=from.path;
          var linkOriginal=to.path;
          var link=to.path.split('/');
          if (link.length==3){
            this.navActive=linkOriginal;
            this.tapActive=linkOriginal;
          }else {
            this.navActive='/'+link[1]+'/'+link[2];
            this.tapActive='/'+link[1]+'/'+link[2];
            this.navChildActive='/'+link[3];
            this.childNone=true;
            if (link[3]=='newsDetail'){
              this.navActive='/'+link[1]+'/'+link[2];
              this.tapActive='/'+link[1]+'/'+link[2];
            }else if(link[3]=='realtyDetail'){
              this.navActive='/'+link[1]+'/'+link[2];
              this.tapActive='/'+link[1]+'/'+link[2];
              this.navChildActive='/realty';
            }else if(link[3]=='subsidiaryDetail'){
              this.navActive='/'+link[1]+'/'+link[2];
              this.tapActive='/'+link[1]+'/'+link[2];
              this.navChildActive='/subsidiary';
            }else if(link[3]=='reportDetail'){
              this.navActive='/'+link[1]+'/'+link[2];
              this.tapActive='/'+link[1]+'/'+link[2];
              this.navChildActive='/report';
            }
          }
        }

      },
      created(){
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf("Safari") > -1) {
          this.isSafari=true;
        }else{
          this.isSafari=false;
        } //判断是否Safari和chrome浏览器，因为Chrome浏览器的userAgent也有Safari字段.
        //此class主要是给sfari加，Chrome加上也不影响，就这样吧
        console.log(this.$store.state.count,'this.$store.state.count')
        var linkOriginal=this.$route.path;
        var link=this.$route.path.split('/');
        if (link.length==3){
          this.navActive=linkOriginal;
          this.tapActive=linkOriginal;
        }else {
          this.navActive='/'+link[1]+'/'+link[2];
          this.tapActive='/'+link[1]+'/'+link[2];
          this.navChildActive='/'+link[3];
          this.childNone=true;
          if (link[3]=='newsDetail'){
            this.navActive='/'+link[1]+'/'+link[2];
            this.tapActive='/'+link[1]+'/'+link[2];
          }else if(link[3]=='realtyDetail'){
            this.navActive='/'+link[1]+'/'+link[2];
            this.tapActive='/'+link[1]+'/'+link[2];
            this.navChildActive='/realty';
          }else if(link[3]=='subsidiaryDetail'){
            this.navActive='/'+link[1]+'/'+link[2];
            this.tapActive='/'+link[1]+'/'+link[2];
            this.navChildActive='/subsidiary';
          }else if(link[3]=='reportDetail'){
            this.navActive='/'+link[1]+'/'+link[2];
            this.tapActive='/'+link[1]+'/'+link[2];
            this.navChildActive='/report';
          }
        }

      },
      methods: {
        searchFn(){
          var isHave=false;
          for(let i=0;i<this.navList.length;i++){
            if (!this.navList[i].navChildList){
              if (this.navList[i].name.indexOf(this.searchMsg)!=-1 ){
                this.$router.push({path:this.navList[i].toLink});
                isHave=true;
              }
            }else {
              for (let j=0;j<this.navList[i].navChildList.length;j++){
                if (this.navList[i].name.indexOf(this.searchMsg)!=-1){
                  this.$router.push({path:this.navList[i].toLink+this.navList[i].navChildList[0].toLink});
                  isHave=true;
                }else if(this.navList[i].navChildList[j].name.indexOf(this.searchMsg)!=-1){
                  this.$router.push({path:this.navList[i].toLink+this.navList[i].navChildList[j].toLink});
                  isHave=true;
                }
              }
            }
          }
          if (!isHave){
            this.$router.push({path:`/main/searchResult?title=${this.searchMsg}`});
          }
        },
        blurFn(){
          this.searchMsg=''
        },
        isChildBlock(txt,toLink){
          this.navActive=toLink;
          if (txt =='r'){
            this.childNone=false;
          }else if(txt =='c'){
            this.childNone=true;
          }
        },
        restoreActive(){
          this.navActive= this.tapActive;
        },
        navChange(txt,toLink,toLinkC){

          //一级导航
          if (txt=='nav' && toLink == '/main/index'){
            this.$router.push({path: toLink});
            this.navActive=toLink;
            this.tapActive=toLink;
            this.navChildActive='';
          }else if (txt == 'nav' && toLink == '/main/newsNotice'){
            this.$router.push({path: toLink});
            this.navActive=toLink;
            this.tapActive=toLink;
            this.navChildActive='';
          }else if (txt == 'nav'){
            this.$router.push({path: toLink+toLinkC[0].toLink});
            this.navActive=toLink;
            this.tapActive=toLink;
            this.navChildActive='';
          }

          //二级导航
          if (toLinkC!=undefined){
            this.navActive=toLink;
            this.tapActive=toLink;
            this.navChildActive=toLinkC;
            this.childNone=true;
            this.$emit('goBack')
          }
        }
      }
    }
</script>

<style scoped lang="less">
  .content{
    height:1.2rem;
    width:12rem;
    position: relative;
      .logo{
        height: 1.2rem;
        line-height:1.2rem;
        float: left;
          >img{
             vertical-align: middle;
             max-width:1.7rem;
             height:.5rem;
          }
      }
      .nav{
        display: block;
        margin-left:.2rem;
        float: left;
        >li{
           float: left;
           height:1.2rem;
           line-height:1.2rem;
           padding: 0 .16rem;
           cursor: pointer;
           font-size:.18rem;
           color: #000;
           position: relative;
           >div{
              position: absolute;
              bottom:0;
              left:0;
              width:100%;
              height:0rem;
              background: #F53A37;
              transition: height .6s ease;
              -webkit-transition: height .6s ease;/* Safari */
              z-index: -1;
            }
         }
         >li:hover,.active{
            color: #fff;
            >div{
               height:100%;
             }
            ol{
              height:1.2rem;
              opacity:1;
              visibility: inherit;
            }
          }
          ol{
            position: absolute;
            top:1.2rem;
            left:0;
            height:0rem;
            width:15rem;
            opacity:0;
            visibility: hidden;
            transition: height .6s ease,opacity .8s ease-out;
            -webkit-transition: height .6s ease,opacity .8s ease-out;/* Safari */
            padding-left: 1rem;
            background: #4B4444;
            z-index:3;
            li{
              float: left;
              height:100%;
              line-height:1.2rem;
              cursor: pointer;
              color: #fff;
               div{
                 font-size:.16rem;
                 padding: 0 .2rem;
               }
            }
            li:hover,.activeChild{
              color: #F53A37;
            }
          }
          .activeChildNone{
            height:0rem!important;
            opacity:0!important;
            visibility: hidden!important;
          }
      }
      .search{
        border-left: 1px solid #CCC;
        /*padding-left:.2rem;*/
        height:1.2rem;
        line-height:1.2rem;
        width:1.9rem;
        position: relative;
        float:left;
         >div{
            border:.01rem solid #c5c5c5;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 1.7rem;
            height: .5rem;
            margin: auto;
            max-width:1.7rem;
            -webkit-border-radius:.05rem;
            -moz-border-radius: .05rem;
            border-radius:.05rem;
            overflow: hidden;
            padding:.1rem 0;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            background:rgba(238,238,238,1);
              img{
                 position: absolute;
                 top:.15rem;
                 left:.1rem;
                 height:.24rem;
                 width:.24rem;
                 z-index: 2;
               }
              input{
                background:rgba(238,238,238,1);
                box-sizing: border-box;
                height: .3rem;
                line-height:.2rem;
                position: absolute;
                left:.05rem;
                font-size:.16rem;
                width:1rem;
                margin-left: .35rem;
                /*padding:.05rem .1rem .05rem .35rem;*/
                color: #999;
                border:0;
                caret-color:red;
              }
            }
            /*div.compatible-safari{*/
              /*input { color: red; }*/
              /*input::first-line { color: #999; }*/
              /*红光标没有兼容safari，如果兼容safari光标大小（input里的字体大小）会出现问题。
            /*}*/
      }
      #child{
        position: absolute;
        width: 2rem;
        top: .2rem!important;
        left:calc(50% + 5.2rem)!important;
        .txt{
          font-weight: 500;
          font-size: .18rem;
          margin-bottom: .1rem;
          line-height: .3rem;
        }
        .text{
          width: 1rem;
          background:rgba(238,238,238,1);
          font-size:.16rem;
          color: #999;
          border:.01rem solid #c5c5c5;
          height: .25rem;
          border-radius: .05rem;
          padding: 0 .1rem;
        }
        input:-webkit-autofill {
          -webkit-box-shadow: 0 0 0px 1000px #eee inset;
          border: 1px solid #CCC!important;
        }
        .btn{
          border: none;
          border-radius: .1rem;
          padding: .04rem .08rem;
          cursor: pointer;
          box-shadow: 0 0 2px 2px #ccc inset;
          margin-top: .1rem;

        }
      }


  }


</style>



// WEBPACK FOOTER //
// src/components/header.vue